document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('.contact-form');
  if (!form) return;
  
  const submitButton = form.querySelector('.button');
  const originalButtonText = submitButton ? submitButton.value : '';
  const categorySelect = form.querySelector('[id*="contactFormCategory"]');

  // 初始化：隱藏除了類別選擇以外的所有欄位
  function initializeForm() {
      const allFields = form.querySelectorAll('.form-field:not(.category-field), .form-actions');
      allFields.forEach(field => {
          field.classList.add('hidden-field');
      });
      form.classList.remove('form-expanded');
  }

  // 展開表單顯示所有欄位
  function expandForm() {
      form.classList.add('form-expanding');
      
      setTimeout(() => {
          form.classList.add('form-expanded');
          
          const hiddenFields = form.querySelectorAll('.hidden-field');
          hiddenFields.forEach((field, index) => {
              setTimeout(() => {
                  field.classList.remove('hidden-field');
              }, index * 100); // 每個欄位延遲100ms顯示，創造連續動畫效果
          });
          
          form.classList.remove('form-expanding');
      }, 100);
  }

  // 收起表單只顯示類別選擇
  function collapseForm() {
      const allFields = form.querySelectorAll('.form-field:not(.category-field), .form-actions');
      allFields.forEach(field => {
          field.classList.add('hidden-field');
      });
      form.classList.remove('form-expanded');
  }

  // 初始化表單
  initializeForm();

  // 類別選擇變更事件
  if (categorySelect) {
      categorySelect.addEventListener('change', function() {
          if (this.value) {
              // 有選擇類別，展開表單
              expandForm();
              
              // 根據選擇的類別動態調整表單內容
              adjustFormForCategory(this.value);
          } else {
              // 沒有選擇，收起表單
              collapseForm();
          }
      });
  }

  // 根據選擇的類別調整表單
  function adjustFormForCategory(category) {
      const productSelect = form.querySelector('[id*="contactFormProduct"]');
      if (!productSelect) return;

      // 先清空所有選項
      productSelect.innerHTML = '';

      // 偵測語系 (Shopify.locale 或 HTML lang)
      const locale = Shopify.locale || document.documentElement.lang || 'en';

      // 準備靜態產品清單，對所有已選分類一視同仁
      let options = [];
      if (locale === 'zh-TW') {
          options = [
              'Hikaru 智慧咖啡機',
              'Samantha II 智慧咖啡機',
              'Samantha 智慧咖啡機',
              'Jimmy 咖啡電子秤',
              '咖啡粒徑卡',
              'Jimmy與保護墊',
              '保護墊',
              '100克校正法碼',
              '其他產品'
          ];
      } else if (locale.startsWith('ja')) {
          options = [
              'Hikaru ブリューワー',
              'Samantha II ブリューワー',
              'Samantha ブリューワー',
              'Jimmy コーヒースケール',
              'コーヒーグラインドサイズカード',
              'Jimmyと保護パッド',
              '保護パッド',
              '100g校正分銅',
              'その他製品'
          ];
      } else {
          options = [
              'Hikaru Brewer',
              'Samantha II Brewer',
              'Samantha Brewer',
              'Jimmy Coffee Scale',
              'Coffee Grind Size Card',
              'Jimmy With Protective Pad Bundle',
              'Jimmy Protective Pad',
              '100g Calibration Weight',
              'Others'
          ];
      }

      // 根據語系決定 placeholder 文案
      const placeholderText = locale === 'zh-TW'
          ? '請選擇產品'
          : locale.startsWith('ja')
              ? '製品を選択してください'
              : 'Please select a product';

      // 先插入 placeholder option
      const placeholderOption = document.createElement('option');
      placeholderOption.value = '';
      placeholderOption.textContent = placeholderText;
      productSelect.appendChild(placeholderOption);

      // 插入所有選項
      options.forEach(name => {
          const optElem = document.createElement('option');
          optElem.value = name;
          optElem.textContent = name;
          productSelect.appendChild(optElem);
      });
  }

  // 檢測語言並設置標題（備用方案，如果 CSS 無法正確檢測）
  function setLanguageTitle() {
      const lang = document.documentElement.lang || 
                  document.querySelector('html').getAttribute('lang') || 
                  navigator.language || 
                  'zh-TW';
      
      const langCode = lang.toLowerCase().substring(0, 2);
      const specificLang = lang.toLowerCase();
      
      // 如果 HTML 沒有正確的 lang 屬性，JavaScript 作為備用
      if (!document.documentElement.lang) {
          const initialTitles = {
              'zh': specificLang.includes('tw') || specificLang.includes('hant') ? '需要幫忙嗎' : '需要帮忙吗？',
              'en': 'Need help?',
              'ja': 'お手伝いが必要ですか？',
              'ko': '도움이 필요하신가요？'
          };
          
          const expandedTitles = {
              'zh': specificLang.includes('tw') || specificLang.includes('hant') ? 'How can we help?' : 'How can we help?',
              'en': 'How can we help?',
              'ja': 'どのようにお手伝いできますか',
              'ko': '어떻게 도와드릴까요'
          };
          
          const initialTitle = initialTitles[langCode] || '需要幫忙嗎';
          const expandedTitle = expandedTitles[langCode] || 'How can we help?';
          
          // 使用 CSS 自定義屬性設置標題
          document.documentElement.style.setProperty('--contact-form-title-initial', `"${initialTitle}"`);
          document.documentElement.style.setProperty('--contact-form-title-expanded', `"${expandedTitle}"`);
          
          // 添加 CSS 規則來使用自定義屬性
          if (!document.querySelector('#dynamic-title-style')) {
              const style = document.createElement('style');
              style.id = 'dynamic-title-style';
              style.textContent = `
                  .contact-form::before {
                      content: var(--contact-form-title-initial, "需要幫忙嗎") !important;
                  }
                  .contact-form.form-expanded::before {
                      content: var(--contact-form-title-expanded, "How can we help?") !important;
                  }
              `;
              document.head.appendChild(style);
          }
      }
  }

  // 載入時設置語言標題
  setLanguageTitle();

  // 多語言載入狀態文字
  function getLoadingText() {
      const lang = document.documentElement.lang || navigator.language || 'zh-TW';
      const langCode = lang.toLowerCase().substring(0, 2);
      const specificLang = lang.toLowerCase();
      
      const loadingTexts = {
          'zh': specificLang.includes('tw') || specificLang.includes('hant') ? '提交中...' : '提交中...',
          'en': 'Submitting...',
          'ja': '送信中...',
          'ko': '제출 중...',
          'fr': 'Envoi en cours...',
          'de': 'Wird gesendet...',
          'es': 'Enviando...',
          'it': 'Invio in corso...',
          'pt': 'Enviando...',
          'ru': 'Отправка...',
          'ar': 'جارٍ الإرسال...',
          'th': 'กำลังส่ง...',
          'vi': 'Đang gửi...'
      };
      
      return loadingTexts[langCode] || '提交中...';
  }

  // 表單驗證函數
  function validateField(field) {
      const fieldContainer = field.closest('.form-field');
      const value = field.value.trim();
      let isValid = true;

      // 移除之前的錯誤狀態
      fieldContainer.classList.remove('form-field--error');
      field.classList.remove('error');

      if (field.hasAttribute('required') && !value) {
          isValid = false;
      } else if (field.type === 'email' && value) {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          isValid = emailRegex.test(value);
      }

      if (!isValid) {
          fieldContainer.classList.add('form-field--error');
          field.classList.add('error');
      }

      return isValid;
  }

  // 即時驗證
  const inputs = form.querySelectorAll('.form-input[required], .form-select[required]');
  inputs.forEach(input => {
      input.addEventListener('blur', function() {
          // 只在表單展開後才驗證
          if (form.classList.contains('form-expanded')) {
              validateField(this);
          }
      });

      input.addEventListener('input', function() {
          if (this.closest('.form-field').classList.contains('form-field--error')) {
              validateField(this);
          }
      });

      input.addEventListener('change', function() {
          if (this.closest('.form-field').classList.contains('form-field--error')) {
              validateField(this);
          }
      });
  });

  // 表單提交處理
  form.addEventListener('submit', function(e) {
      // 如果表單還沒有展開，阻止提交
      if (!form.classList.contains('form-expanded')) {
          e.preventDefault();
          return false;
      }

      let isFormValid = true;
      
      // 只驗證可見的必填欄位
      const visibleRequiredInputs = form.querySelectorAll('.form-input[required]:not(.hidden-field input), .form-select[required]:not(.hidden-field select)');
      visibleRequiredInputs.forEach(input => {
          if (!input.closest('.form-field').classList.contains('hidden-field')) {
              if (!validateField(input)) {
                  isFormValid = false;
              }
          }
      });

      if (!isFormValid) {
          e.preventDefault();
          
          // 聚焦到第一個錯誤欄位
          const firstError = form.querySelector('.form-field--error .form-input, .form-input.error, .form-field--error .form-select, .form-select.error');
          if (firstError) {
              firstError.focus();
          }
          
          return false;
      }

      // 如果表單有效，顯示載入狀態
      if (submitButton) {
          submitButton.disabled = true;
          submitButton.value = getLoadingText();
          
          // 設定 timeout 來恢復按鈕狀態（以防網路問題）
          setTimeout(() => {
              submitButton.disabled = false;
              submitButton.value = originalButtonText;
          }, 30000); // 30秒後恢復
      }
  });

  // 電話號碼格式化
  const phoneInput = form.querySelector('[type="tel"]');
  if (phoneInput) {
      phoneInput.addEventListener('input', function(e) {
          // 移除所有非數字字符（除了 +、-、空格、括號）
          let value = e.target.value.replace(/[^\d\+\-\s\(\)]/g, '');
          e.target.value = value;
      });
  }

  // 留言字符計數器
  const messageField = form.querySelector('textarea');
  if (messageField) {
      const maxLength = 1000; // 設定最大字符數
      
      // 查找或創建字符計數器
      let charCounter = document.getElementById('charCounter');
      if (!charCounter) {
          charCounter = document.createElement('div');
          charCounter.id = 'charCounter';
          charCounter.className = 'char-counter';
          messageField.parentNode.appendChild(charCounter);
      }
      
      function updateCharCount() {
          const currentLength = messageField.value.length;
          const remaining = maxLength - currentLength;
          charCounter.textContent = `${currentLength}/${maxLength}`;
          
          // 更新樣式
          charCounter.className = 'char-counter';
          if (remaining < 100) {
              charCounter.classList.add('danger');
          } else if (remaining < 200) {
              charCounter.classList.add('warning');
          }
          
          // 限制輸入長度
          if (currentLength > maxLength) {
              messageField.value = messageField.value.substring(0, maxLength);
              charCounter.textContent = `${maxLength}/${maxLength}`;
              charCounter.className = 'char-counter danger';
          }
      }
      
      messageField.addEventListener('input', updateCharCount);
      messageField.addEventListener('paste', function() {
          setTimeout(updateCharCount, 0);
      });
      updateCharCount(); // 初始化
  }

  // 檔案上傳處理
  const fileInput = form.querySelector('[type="file"]');
  if (fileInput) {
      const fileButton = fileInput.parentNode.querySelector('.file-upload-button span');
      if (fileButton) {
          fileInput.addEventListener('change', function() {
              if (this.files && this.files[0]) {
                  fileButton.textContent = this.files[0].name;
              } else {
                  fileButton.textContent = fileButton.textContent || '選擇檔案';
              }
          });
      }
  }

  // 成功訊息自動滾動到頂部
  const successMessage = form.querySelector('.alertBox--success');
  if (successMessage) {
      setTimeout(() => {
          form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
  }

  // 為現有錯誤欄位添加樣式
  const existingErrors = form.querySelectorAll('.form-field--error');
  existingErrors.forEach(field => {
      const input = field.querySelector('.form-input, .form-select');
      if (input) {
          input.classList.add('error');
      }
  });

  // 自動保存草稿功能（本地存儲）
  function saveDraft() {
      const formData = {};
      const inputs = form.querySelectorAll('input, select, textarea');
      inputs.forEach(input => {
          if (input.name && input.type !== 'hidden' && input.type !== 'submit') {
              formData[input.name] = input.value;
          }
      });
      localStorage.setItem('contactFormDraft', JSON.stringify(formData));
  }

  function loadDraft() {
      try {
          const draft = localStorage.getItem('contactFormDraft');
          if (draft) {
              const formData = JSON.parse(draft);
              Object.keys(formData).forEach(name => {
                  const input = form.querySelector(`[name="${name}"]`);
                  if (input && !input.value) {
                      input.value = formData[name];
                      
                      // 如果是類別選擇且有值，自動展開表單
                      if (input === categorySelect && formData[name]) {
                          expandForm();
                          adjustFormForCategory(formData[name]);
                      }
                  }
              });
          }
      } catch (e) {
          console.log('載入草稿失敗:', e);
      }
  }

  function clearDraft() {
      localStorage.removeItem('contactFormDraft');
  }

  // 載入草稿
  loadDraft();

  // 自動保存（每30秒或當用戶停止輸入5秒後）
  let saveTimeout;
  form.addEventListener('input', function() {
      clearTimeout(saveTimeout);
      saveTimeout = setTimeout(saveDraft, 5000); // 5秒後保存
  });

  // 表單成功提交後清除草稿
  form.addEventListener('submit', function() {
      setTimeout(clearDraft, 1000); // 1秒後清除草稿
  });

  // 定期自動保存
  setInterval(saveDraft, 30000); // 每30秒保存一次

  // 頁面離開前保存草稿
  window.addEventListener('beforeunload', saveDraft);

  // 鍵盤快捷鍵支援
  document.addEventListener('keydown', function(e) {
      // Escape 鍵收起表單
      if (e.key === 'Escape' && form.classList.contains('form-expanded')) {
          if (categorySelect) {
              categorySelect.value = '';
              categorySelect.dispatchEvent(new Event('change'));
          }
      }
      
      // Ctrl + Enter 或 Cmd + Enter 提交表單
      if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
          if (form.contains(document.activeElement) && form.classList.contains('form-expanded')) {
              form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
      }
  });
});